import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import ExcelJS from 'exceljs'

import { useModalContext } from '../../../ui'
import { dataToXLS, getFormattedTime } from '../../../core/utils'
import { ExportNotEmptyDialog } from '../components/dialogs'
import { useAjaxContext } from '../../../core/ajax'
import { applicationDataPreparation } from '../logics'
import { useApplicationUserPermitsContext } from '../../../pages/applications/contexts'

export const useApplicationExports = () => {
  const intl = useIntl()
  const search = useSelector((state) => state.applications.search)
  const pagination = useSelector((state) => state.applications.pagination)
  const combos = useSelector((state) => state.combos)
  const [loading, setLoading] = useState(false)
  const { get } = useAjaxContext()
  const { columns_export, appUrl } = useApplicationUserPermitsContext()

  const {
    actions: { open },
  } = useModalContext()

  const mainExport = async (data) => {
    try {
      const result = dataToXLS(data, columns_export, combos, intl)

      if (!result || !Array.isArray(result) || result.length === 0) {
        console.error('No hay datos para exportar')
        setLoading(false)
        return
      }

      const workbook = new ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet('SheetJS')

      result.forEach((row, index) => {
        worksheet.addRow(row)

        if (index === 0) {
          const headerRow = worksheet.getRow(1)
          headerRow.font = { bold: true }
          headerRow.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFE0E0E0' },
          }
        }
      })

      worksheet.columns.forEach((column) => {
        let maxLength = 0
        column.eachCell({ includeEmpty: true }, (cell) => {
          const columnLength = cell.value ? cell.value.toString().length : 10
          if (columnLength > maxLength) {
            maxLength = columnLength
          }
        })
        column.width = maxLength < 10 ? 10 : maxLength + 2
      })

      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `solicitudes_${getFormattedTime()}.xlsx`
      link.click()
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Error al exportar:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleExportAll = async () => {
    setLoading(true)
    const { _num_x_pagina, _pagina, ...otherSearch } = search
    const { total_solicitudes } = pagination
    if (!total_solicitudes) {
      open({
        Component: ExportNotEmptyDialog,
      })
      setLoading(false)
      return
    }
    get(appUrl, {
      params: { ...otherSearch, _num_x_pagina: total_solicitudes, _pagina: '1' },
      timeout: 0,
    })
      .then(async ({ data }) => {
        const recievedData = applicationDataPreparation(data.solicitudes, { intl }, columns_export)
        await mainExport(recievedData)
      })
      .catch(({ response }) => {
        setLoading(false)
      })
  }

  return { loading, setLoading, mainExport, handleExportAll }
}
